/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { colors } from "@farmlands/mui-theme";
import { AppBar, Box, styled } from "@mui/material";
import React from "react";

import { MobileCartHeader } from "../features/cart/components/MobileCartHeader";
import { APPBAR_HEIGHT } from "../util/consts";

const MobileCartAppbar = styled(AppBar)(({ theme }) => ({
  position: "fixed",
  height: `calc(${APPBAR_HEIGHT.sm}px + var(--app-safe-area-top))`,
  background: colors.primary50,
  boxShadow: "0px 6px 12px 0px rgba(0, 0, 0, 0.10)",
  ...theme.mixins.pagePadding,
  paddingTop: "var(--app-safe-area-top) !important",
  paddingBottom: "0px !important",
  display: "flex",
  justifyContent: "center",
}));

export const MobileHeader = () => {
  return (
    <MobileCartAppbar>
      <Box>
        <div className="mt-auto flex-1">
          <MobileCartHeader />
        </div>
      </Box>
    </MobileCartAppbar>
  );
};
